// Copyright (c) Docugami, Inc. All rights reserved.

import { DocExplorerInfoLabel } from "components/common/Fonts"
import styled from "styled-components"

const PlaceholderContainer = styled.div<{isLink: boolean}>`
    height: 160px;
    text-align: center;
    display: flex;
    :hover {
        text-decoration: ${props => props.isLink ? "underline" : "default"};
        cursor: ${props => props.isLink ? "pointer" : "default"};
    }
`

const LabelContainer = styled.div`
    max-width: 75%;
    margin: auto;
`

interface PlaceholderTextProps {
    text: string;
    onClick?: () => void;
}

export const PlaceholderText = (props: PlaceholderTextProps): JSX.Element => {
    return (
        <PlaceholderContainer isLink={!!props.onClick} onClick={props.onClick}>
            <LabelContainer>
                <DocExplorerInfoLabel>{props.text}</DocExplorerInfoLabel>
            </LabelContainer>
        </PlaceholderContainer>
    )
}
